import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Box, Button, Chip, Typography, useTheme } from "@mui/material";
import ShadowBox from "../layout/container/ShadowBox";
import SimpleBox from "../layout/container/SimpleBox";
import AddButton from "../input/button/AddButton";
import { updateCurrentPersonId } from "../../store/user";

// Shown on the home page, right after the carousel, to whoever is logged in
// and already has at least one associated Person — people with more than one
// registered member (e.g. several children) kept missing the "add another
// member" link entirely because it only lived inside the Área de Membro's
// "Pedidos em Curso" section, so it's surfaced here too.
const HomeMemberInfo = ({ people = [], currentPersonId }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const hasMultiple = people.length > 1;

    const selectPerson = (personId) => {
        dispatch(updateCurrentPersonId(personId));
        navigate("/membership");
    }

    return (
        <ShadowBox title="A tua Área de Membro" titleVariant="h3" mt={6}>
            {
                hasMultiple ? (
                    <SimpleBox fullWidth={true} flexDirection="column" gap={2} alignItems="left">
                        <Typography>
                            Estas são as pessoas associadas à tua conta. Escolhe uma para aceder aos seus dados,
                            pagamentos e pedidos:
                        </Typography>
                        <Box display="flex" flexWrap="wrap" gap={theme.spacing(2)}>
                            {
                                people.map((person) => (
                                    <Chip
                                        key={person.id}
                                        label={person.shortName ?? person.fullName}
                                        clickable
                                        onClick={() => selectPerson(person.id)}
                                        color={person.id === currentPersonId ? "primary" : "default"}
                                        variant={person.id === currentPersonId ? "filled" : "outlined"}
                                    />
                                ))
                            }
                        </Box>
                    </SimpleBox>
                ) : (
                    <Typography>
                        Olá, {people[0]?.shortName ?? people[0]?.fullName}! Consulta a tua Área de Membro para
                        gerir os teus dados, pagamentos e pedidos.
                    </Typography>
                )
            }
            <Box mt={theme.spacing(4)} display="flex" flexWrap="wrap" alignItems="center" gap={theme.spacing(4)}>
                {
                    !hasMultiple ? (
                        <Button variant="contained" color="primary" size="small" onClick={() => navigate("/membership")}>
                            Ir para a minha Área de Membro
                        </Button>
                    ) : null
                }
                <AddButton label="Adicionar Novo Sócio" onClick={() => navigate("/edit-member/NEW/null")} />
            </Box>
        </ShadowBox>
    );
}

export default HomeMemberInfo;
